// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoicePlayer__audio-d4e872 {
  box-sizing: border-box;
  display: flex;
  flex: 1;
}

.VoicePlayer__play-container-aced86 {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  cursor: pointer;
}

.VoicePlayer__controls-container-d12e3b {
  flex: 1 1 auto;
  overflow: auto;
  margin-inline-start: 8px;
}

.VoicePlayer__time-c852f1 {
  margin-top: 6px;
  color: var(--chat-bubble-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/components/VoicePlayer/VoicePlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,OAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,wCAAA;AACF","sourcesContent":[".audio {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n}\n\n.play-container {\n  flex: 0 0 auto;\n  width: 48px;\n  height: 48px;\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.controls-container {\n  flex: 1 1 auto;\n  overflow: auto;\n  margin-inline-start: 8px;\n}\n\n.time {\n  margin-top: 6px;\n  color: var(--chat-bubble-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audio": `VoicePlayer__audio-d4e872`,
	"play-container": `VoicePlayer__play-container-aced86`,
	"playContainer": `VoicePlayer__play-container-aced86`,
	"controls-container": `VoicePlayer__controls-container-d12e3b`,
	"controlsContainer": `VoicePlayer__controls-container-d12e3b`,
	"time": `VoicePlayer__time-c852f1`
};
module.exports = ___CSS_LOADER_EXPORT___;
